<template>
  <div class="fill-height overflow-hidden d-flex flex-column">
    <h4 class="text-center text-xs-overline text-lg-h4 ma-1">{{ $store.state.selectedActivity.name }}</h4>
    <div class="flex-grow-1">
      <ZoomRoom
        :meetingNumber="$store.state.selectedActivity.zoomMeetingNumber"
        :meetingCode="$store.state.selectedActivity.zoomMeetingCode"
        :userName="$store.state.participantUsername"
        :hostMode="!!$route.query.host"
        :assistantMode="!!$route.query.assistant"
        :leaveUrl="leaveUrl"
      />
    </div>
  </div>
</template>

<script>
import ZoomRoom from "./components/participant.zoom";

export default {
  data() {
    return {};
  },
  components: {
    ZoomRoom,
  },
  methods: {},
  computed: {
    leaveUrl() {
      return this.$store.state.event.enableLobby ? `/e/${this.$store.state.event.slug}` : null;
    },
  },
  async mounted() {},
};
</script>
